import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import ReportUsersRouter from './ReportUsers/ReportUsersRouter';

const ReportingRouter = () => {
    const { path } = useRouteMatch();

    return (
        <div>
            <Route path={`${path}/report-users`}>
                <ReportUsersRouter />
            </Route>
        </div>
    );
};

export default ReportingRouter;
